import Swal from 'sweetalert2'
import { Theme } from 'baseui/theme';
import { Client } from 'styletron-engine-atomic';

const important = (obj: object) => {
  let out: {[key:string]: string | undefined} = {}
  Object.entries(obj).forEach(([key, val]) => (out[key as string] = typeof val !== 'undefined' ? `${val} !important` : val))
  return out
}

const getInputFields = (domNode: HTMLElement): HTMLElement[] => {
  const inputClasses = ['swal2-input','swal2-file','swal2-range','swal2-select','swal2-radio','swal2-checkbox','swal2-textarea']
  return inputClasses.reduce((acc: HTMLElement[], current: string) => ([...acc, ...(Array.from(domNode.getElementsByClassName(current)) as HTMLElement[])]), ([] as HTMLElement[]) )
}

const Button = (theme: Theme) => ({
  borderRadius: 0,
  padding: '14px 16px',
  ...theme.typography.LabelMedium
})

class SwalConfig {
  static engine: Client | undefined = undefined;
  static theme: Theme | undefined = undefined;
  static meta = {
    isDefault: true
  };
  static getConfig(){
    if(!SwalConfig.engine || !SwalConfig.theme) {
      return Swal
    }
    const { isDefault } = SwalConfig.meta;
    return Swal.mixin({
      customClass: {
        container: SwalConfig.engine.renderStyle({
          fontFamily: SwalConfig.theme.typography.LabelMedium.fontFamily
        }),
        cancelButton: SwalConfig.engine.renderStyle({...important({
          backgroundColor: isDefault ? SwalConfig.theme.colors.backgroundTertiary : SwalConfig.theme.colors.primaryB,
          color: SwalConfig.theme.colors.primaryA,
          ...Button(SwalConfig.theme)
        })}),
        confirmButton: SwalConfig.engine.renderStyle({...important({
          backgroundColor: SwalConfig.theme.colors.primaryA,
          color: SwalConfig.theme.colors.primaryB,
          ...Button(SwalConfig.theme)
        })}),
        denyButton: SwalConfig.engine.renderStyle({...important({
          backgroundColor: isDefault ? SwalConfig.theme.colors.backgroundTertiary : SwalConfig.theme.colors.primaryB,
          color: SwalConfig.theme.colors.primaryA,
          ...Button(SwalConfig.theme)
        })}),
        popup: SwalConfig.engine.renderStyle({
          borderRadius: 0,
          backgroundColor: !isDefault ? SwalConfig.theme.colors.primaryB : undefined,
          color: !isDefault ? SwalConfig.theme.colors.primaryA : undefined,
        }),
        input: SwalConfig.engine.renderStyle({
          borderRadius: 0,
          borderColor: !isDefault ? SwalConfig.theme.colors.primaryA : undefined,
          color: !isDefault ? SwalConfig.theme.colors.primaryA : undefined,
          "::placeholder": { color: !isDefault ? SwalConfig.theme.colors.primaryA : undefined},
          ":focus": isDefault ? {} : { ...important({border: `1px solid ${SwalConfig.theme.colors.primaryA}`, boxShadow: `0 0 0 3px ${SwalConfig.theme.colors.primaryA}`})}
        }),
        icon: SwalConfig.engine.renderStyle({...important({
          color: !isDefault ? SwalConfig.theme.colors.primaryA : undefined,
          borderColor: !isDefault ? SwalConfig.theme.colors.primaryA : undefined,
        })}),
        title: SwalConfig.engine.renderStyle({...important({
          color: !isDefault ? SwalConfig.theme.colors.primaryA : undefined,
        })}),
        //content: SwalConfig.engine.renderStyle({...important({
        //  color: !isDefault ? SwalConfig.theme.colors.primaryA : undefined,
        //})}),
        validationMessage: SwalConfig.engine.renderStyle({...important({
          color: !isDefault ? SwalConfig.theme.colors.primaryA : undefined,
          backgroundColor: !isDefault ? SwalConfig.theme.colors.primaryB : undefined
        }),
        "::before": isDefault ? {} : {
          color: SwalConfig.theme.colors.primaryB,
          backgroundColor: SwalConfig.theme.colors.primaryA
      }}),
      },
      imageAlt: "",
      didOpen: (popup) => {
        const inputs = getInputFields(popup)
        popup.getElementsByClassName('swal2-image')[0].setAttribute('alt', '')
        inputs.filter(inputs => inputs.style.display !== 'none').forEach(input => input.setAttribute('aria-label', input.getAttribute('placeholder') || ''))
      }
    })
  }

  static renderer(engine?: Client, theme?: Theme, isDefault?: boolean) {
    if(engine)
      SwalConfig.engine = engine;
    if(theme)
      SwalConfig.theme = theme;
    if(typeof isDefault !== 'undefined')
      SwalConfig.meta = { isDefault: isDefault }
  }
}
export const renderer = SwalConfig.renderer
export default () => SwalConfig.getConfig()